import React, { useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import {
    Form,
    Input,
    Select,
    Modal,
    Typography,
    Button,
    DatePicker,
    notification,
} from "antd";
import moment from "moment";
import dayjs from "dayjs";
import WasteApi from "../../Apis/WasteApi";
import RuntimeConfigsApi from "../../Apis/RuntimeConfigsApi";
import ProductionApi from "../../Apis/ProductionApi";
const { Title } = Typography;
function AddWaste({ visible, onClose, ProductionDetails, ingredientDetails }) {
    const [formAdd] = Form.useForm();
    const UserDetails = JSON.parse(localStorage.getItem("UserDetails"));
    const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
    const CURRENCY = decodedToken.currency === "USD" ? "$" : "€";
    const [isLoading, setLoading] = React.useState(false);
    
    console.log("ProductionDetails");
    console.log(ProductionDetails);
    
    // Check if it's a recipe (multiple ingredients) or raw production (single ingredient)
    const isRecipe = ingredientDetails?.length > 1 || ProductionDetails?.rawProduction === false;
    
    if (ProductionDetails) {
        formAdd.setFieldsValue({
            productId: ProductionDetails?.recipeDTO?.recipeName,
            cookName: decodedToken?.name,
            SellDate: dayjs(ProductionDetails?.sellByDate),
            productionCoast: ProductionDetails?.productionCoast?.toFixed(2),
            quantityDisplay: parseFloat(ProductionDetails?.quantity).toFixed(2),
            unitDisplay: ProductionDetails?.unit,
            // For recipe, set the unit to the production unit
            unit: isRecipe ? ProductionDetails?.unit : null,
        });
    }

    const handleInputKeyDown = (event) => {
        if (event.key === '-') {
            event.preventDefault();
        }
    };

    const handleSubmit = (data) => {
        setLoading(true);
        const sellDate = dayjs(data.SellDate).format("DD/MM/YYYY");
        var unitNoOfWaste = 0;
        if (ingredientDetails?.length > 1) {
            unitNoOfWaste = 3;
        }
        else {
            unitNoOfWaste = data.unit === ingredientDetails[0]?.productDTO.unitUomOne ? 1 : 
                           data.unit === ingredientDetails[0]?.productDTO.unitUomTwo ? 2 : 3;
        }
        let formData = JSON.stringify({
            productionName: ProductionDetails?.recipeDTO?.recipeName,
            unit: isRecipe ? ProductionDetails?.unit : data.unit,
            quantity: data.quantity,
            userId: decodedToken?.userId,
            cookName: data.cookName,
            dateOfCooking: ProductionDetails?.dateOfCooking,
            newSellByDateOfTheProduct: convertToUnixTimestamp(sellDate),
            productionCoast: data.productionCoast,
            currency: CURRENCY,
            reason: data.reason,
            rawProduction: ingredientDetails?.length > 1 ? false : true,
            uomNumberOfWaste: unitNoOfWaste,
            institutionDTO: {
                id: ProductionDetails?.institutionDTO?.id,
            },
            productionDTO: {
                id: ProductionDetails?.id,
                recipeDTO: {
                    id: ProductionDetails?.recipeDTO?.id,
                    recipeName: ProductionDetails?.recipeDTO?.recipeName,
                }
            },
            tenantDTO: {
                id: decodedToken?.tenantId,
                tenantApiKey: decodedToken?.tenantApiKey,
            },
        });
        WasteApi.CreateproductWaste(formData)
            .then((response) => {
                notification.open({
                    message: <span style={{ fontWeight: "bold" }}>Created</span>,
                    description: "Created Successfully",
                    closeIcon: false,
                    duration: 3,
                    style: {
                        backgroundColor: "#b3ffb3",
                        color: "green",
                    },
                });
                setTimeout(() => {
                    window.location.reload();
                }, 500);
            })
            .catch((err) => {
                setLoading(false);
                console.log(err);
                if (err.apiError.status) {
                    notification.open({
                        message: <span style={{ fontWeight: "bold" }}>{err.apiError.status}</span>,
                        description: err.apiError.message,
                        closeIcon: false,
                        duration: 3,
                        style: {
                            backgroundColor: "#fff2f0",
                            color: "red",
                        },
                    });
                }
            });
    };

    function convertToUnixTimestamp(dateString) {
        const parts = dateString.split("/");
        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1;
        const year = parseInt(parts[2], 10);
        const unixTimestamp = Date.UTC(year, month, day);
        return unixTimestamp;
    }

    const currentDate = moment().format("DD/MM/YYYY");

    const handleCancel = () => {
        formAdd.resetFields();
        onClose();
    };

    return (
        <>
            <Modal
                footer={[]}
                width={600}
                visible={visible}
                maskClosable={false}
                onCancel={handleCancel}
                onOk={onClose}
            >
                <Title level={4} className="text-center Primary-Font mb-4 pb-3">
                    Waste
                </Title>
                <Form
                    form={formAdd}
                    name="nest-messages"
                    layout="horizontal"
                    labelCol={{
                        span: 9,
                    }}
                    wrapperCol={{
                        span: 15,
                    }}
                    className="FormClass IndividualProduct-Model"
                    onFinish={handleSubmit}
                >
                    <>
                        <div className="Product-createDate">
                            <div className="mb-3" style={{ display: 'flex', fontSize: '18px', alignItems: 'center' }}>
                                <b className="mx-2">{currentDate}</b>
                                <img
                                    src="/assest/Images/cal.png"
                                    style={{ width: '32px' }}
                                    className="logo-png"
                                />
                            </div>
                            <Form.Item
                                name="createDate"
                                initialValue={dayjs(currentDate, "DD/MM/YYYY")}
                                className="text-lable col-lg-6 col-sm-12 col-md-7 d-none"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please enter Date.",
                                    },
                                ]}
                            >
                                <DatePicker
                                    format={"DD/MM/YYYY"}
                                    className="form-control control-input"
                                />
                            </Form.Item>
                        </div>        
                        <Form.Item
                            name="productId"
                            label="Product Description :"
                            className="text-lable disabled"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Select Product Description.",
                                },
                            ]}
                        >
                            <Input
                                disabled
                                type="text"
                                className="control-input"
                            />
                        </Form.Item>                     
                        <Form.Item
                            name="SellDate"
                            label="Sell By date"
                            className="text-lable disabled"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Select Sell By date.",
                                },
                            ]}
                        >
                            <DatePicker
                                format={"DD/MM/YYYY"}
                                disabled
                                className="form-control control-input"
                            />
                        </Form.Item>
                        <div className="row product-row d-flex pt-1 pe-3">
                            <div className="col-2"></div>
                            <div className="col-6">
                                <Form.Item
                                    name="quantityDisplay"
                                    label="Balance Qty"
                                    className="text-lable disabled"
                                >
                                    <Input
                                        type="text"
                                        disabled
                                        className="control-input"
                                    />
                                </Form.Item>
                            </div>
                            <div className="col-4">
                                <Form.Item
                                    name="unitDisplay"
                                    label=""
                                    className="text-lable disabled"
                                >
                                    <Input
                                        disabled
                                        className="control-input"
                                    />
                                </Form.Item>
                            </div>
                        </div>
                        <div className="row product-row d-flex pt-1 pe-3">
                            <div className="col-2"></div>
                            <div className="col-6">
                                <Form.Item
                                    name="quantity"
                                    label="Waste Qty"
                                    className="text-lable"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please enter Quantity.",
                                        },
                                    ]}
                                >
                                    <Input
                                        onKeyDown={handleInputKeyDown}
                                        type="number"
                                        placeholder="Quantity"
                                        className="control-input"
                                    />
                                </Form.Item>
                            </div>
                            <div className="col-4">
                                <Form.Item
                                    name="unit"
                                    label=""
                                    className="text-lable"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please select Unit",
                                        },
                                    ]}
                                >
                                    <Select
                                        className="control-Select mb-3"
                                        placeholder="Select Unit"
                                        // Disable only when it's a recipe (multiple ingredients)
                                        disabled={isRecipe}
                                    >
                                        {isRecipe && (
                                            <option value={ProductionDetails?.unit}>
                                                {ProductionDetails?.unit}
                                            </option>
                                        )}
                                        
                                        {/* For Single Ingredient - show all available units */}
                                        {!isRecipe && ingredientDetails && ingredientDetails.length === 1 && (
                                            <>
                                                {ingredientDetails[0]?.productDTO?.unitUomOne && (
                                                    <option value={ingredientDetails[0].productDTO.unitUomOne}>
                                                        {ingredientDetails[0].productDTO.unitUomOne}
                                                    </option>
                                                )}
                                                {ingredientDetails[0]?.productDTO?.unitUomTwo && (
                                                    <option value={ingredientDetails[0].productDTO.unitUomTwo}>
                                                        {ingredientDetails[0].productDTO.unitUomTwo}
                                                    </option>
                                                )}
                                                {ingredientDetails[0]?.productDTO?.unitUomThree && (
                                                    <option value={ingredientDetails[0].productDTO.unitUomThree}>
                                                        {ingredientDetails[0].productDTO.unitUomThree}
                                                    </option>
                                                )}
                                            </>
                                        )}
                                    </Select>
                                </Form.Item>
                            </div>
                        </div>
                        <Form.Item
                            name="cookName"
                            label="Cook Name"
                            className="text-lable disabled"
                            rules={[
                                {
                                    required: true,
                                    message: "Please enter Cook Name.",
                                },
                            ]}
                        >
                            <Input
                                disabled
                                type="text"
                                placeholder="Cook Name"
                                className="control-input"
                            />
                        </Form.Item>

                        <Form.Item
                            name="productionCoast"
                            label="Production Cost"
                            className="text-lable disabled"
                            rules={[
                                {
                                    required: true,
                                    message: "Please enter Production Cost.",
                                },
                            ]}
                        >
                            <Input
                                disabled
                                type="number"
                                placeholder="Production Cost"
                                className="control-input"
                                style={{
                                    border: 'none',
                                    marginBottom: '0px',
                                }}
                                addonBefore={
                                    <Button
                                        style={{
                                            border: 'none',
                                            padding: 0,
                                            margin: 0,
                                            background: 'none',
                                            cursor: 'pointer',
                                        }}
                                    >
                                        {CURRENCY}
                                    </Button>
                                }
                            />
                        </Form.Item>     
                        <Form.Item
                            name="reason"
                            label="Reason"
                            className="text-lable"
                            rules={[
                                {
                                    required: true,
                                    message: "Please enter Reason.",
                                },
                            ]}
                        >
                            <Input
                                type="text"
                                placeholder="Reason"
                                className="control-input"
                            />
                        </Form.Item>

                        <div
                            className="d-flex justify-content-between pt-4"
                            style={{
                                gap: "10px",
                            }}
                        >
                            <Button
                                onClick={handleCancel}
                                style={{
                                    flex: 1,
                                    height: 40,
                                    borderRadius: 6,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    color: "#000",
                                    textDecoration: "none",
                                    fontWeight: 500,
                                }}
                            >
                                Cancel
                            </Button>

                            <Button
                                type="primary"
                                htmlType="submit"
                                loading={isLoading}
                                style={{
                                    flex: 1,
                                    height: 40,
                                    borderRadius: 6,
                                    fontWeight: 500,
                                }}
                            >
                                Waste
                            </Button>
                        </div>
                    </>
                </Form>
            </Modal>
        </>
    );
}

export default AddWaste;
